module.exports = __webpack_public_path__ + "static/media/cocktail.2eb292a5.svg";